import { makeAutoObservable } from "mobx";
import { AttributeShelf, LoaderShelf } from "../../shelves";
import { api } from "../../services";
import type { ConsentingTerms } from "../../services/APIService/types";
import type { AuthenticationStore } from "../../stores";
import { getAuthenticity } from "../../utils/functions/getAuthenticity";
import { env } from "../../config";

export class WithdrawResumeStore {
	public authentication: AuthenticationStore;
	public loader = new LoaderShelf();
	public isSavedConsentingTerms = new AttributeShelf<boolean>(false);

	constructor(authentication: AuthenticationStore) {
		this.authentication = authentication;
		makeAutoObservable(this);
	}

	// Método de acesso ao isSavedConsentingTerms
	public get getIsSavedConsentingTerms(): boolean {
		return this.isSavedConsentingTerms.value;
	}

	// Método de acesso ao isSavedConsentingTerms
	public setConsentingTerms(value: boolean): void {
		this.isSavedConsentingTerms.set(value);
	}

	// Salva os termos de consentimento na assinatura de contrato
	public handleSaveConsentingTerms = async (isConsentsBigPayLock: boolean): Promise<void> => {
		if (this.loader.isLoading) {
			return;
		}
		this.loader.start();

		const authenticity = await getAuthenticity();
		const { signContractTermsId, vivoPayAwardTermId } = env.ids;

		const body: ConsentingTerms = {
			termIds: isConsentsBigPayLock ? [signContractTermsId, vivoPayAwardTermId] : [signContractTermsId],
			authenticity,
		};

		try {
			await api.postSaveConsentingTerms(this.authentication.getToken() || "", body);
			this.setConsentingTerms(true);
		} catch (error) {
			this.setConsentingTerms(false);
		} finally {
			this.loader.end();
		}
	};
}
